import React from 'react';
import { ActivityIndicator } from 'react-native';
import { colors } from '../../../utils/theme';

export type LoaderSize = 'md' | 'sm';

export type LoaderProps = {
    size?: LoaderSize;
};

const Loader: React.FC<LoaderProps> = (props) => {
    return <ActivityIndicator size={props.size === 'sm' ? 'small' : 'large'} color={colors['Primary-Reg-Dark']} />;
};

export default Loader;
